import { FieldProps } from 'formik'
import React from 'react'
import TextareaAutosize from 'react-textarea-autosize'
import FormField, { FormFieldProps } from './form-field'

interface TextareaFieldProps extends FormFieldProps, FieldProps {
  maxRows?: number
  minRows?: number
}

const TextareaField: React.FunctionComponent<TextareaFieldProps> = props => {
  const { field, form, label, help, required, ...rest } = props
  if (props.field.value === undefined) props.field.value = ''
  const id = `${field.name}-textarea`
  return (
    <FormField
      label={label}
      help={help}
      required={required}
      htmlFor={id}
      error={form.errors[field.name] as string}
    >
      <TextareaAutosize {...field} {...rest} id={id} className="textarea" />
    </FormField>
  )
}

export default TextareaField
